module.exports = __webpack_public_path__ + "img/contact-bg.94d1b218.webp";